<div class="stage " style="padding:0;background:none;border-radius:12px">
  <div class="cta-bar">
    <span class="pulse"></span>
    <span id="ctaText" class="text-uppercase" [innerHTML]="'banner.cta_banner_para' | translate"></span>
    <a [fragment]="'early-access'" routerLink="/" class="text-uppercase">{{"banner.cta_banner_link" | translate}}</a>
    <!-- <a href="#" class="text-uppercase" (click)="onBuyClick()">{{"banner.cta_banner_link" | translate}}</a> -->
    <span class="shine"></span>
  </div>
</div>